<template>
    <div style="overflow-y: scroll;">
        <div v-if="isShowQr" style="position: fixed; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; top: 0; left: 0; background-color: #210f0333;">
            <div style="width: 390px; height:390px; background-color: #fff; border-radius: 24px; position: relative;">
                <div @click="closeQr" style="position: absolute; right: 20px; top: 20px; font-weight: 700; line-height: 24px;">닫기</div>
                <div style="margin-top: 23px; text-align: center;">
                    <img style="width: 70px;" :src="require('@/assets/img/soccerhow_orange.png')" alt="">
                </div>
                <div v-if="!isPro" style="font-weight: 700; line-height: 20px; text-align: center; margin-top: 46px;">QR코드를 스캔하여<br>사커하우 모바일 앱을 다운로드할 수 있습니다.</div>
                <div v-else style="font-weight: 700; line-height: 20px; text-align: center; margin-top: 46px;">포지션 찾기 PRO는 사커하우 앱에서<br>무료로 진행할 수 있습니다</div>
                <div style="margin-top: 40px; display: flex; justify-content: center; gap: 60px;">
                    <div>
                        <div style="display: flex; gap: 4px; align-items: center; justify-content: center; margin-bottom: 4px;">
                            <img style="width: 17px;" :src="require('@/assets/img/app_store.png')" alt="">
                            <div style="font-weight: 500; font-size: 12px;">앱스토어</div>
                        </div>
                        <img style="width: 100px;" :src="require('@/assets/img/ios_qr.png')" alt="">
                    </div>
                    <div>
                        <div style="display: flex; gap: 4px; align-items: center; justify-content: center; margin-bottom: 4px;">
                            <img style="width: 17px;" :src="require('@/assets/img/play_store.png')" alt="">
                            <div style="font-weight: 500; font-size: 12px;">구글플레이</div>
                        </div>
                        <img style="width: 100px;" :src="require('@/assets/img/android_qr.png')" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div :style="{ background: type === POSITION_TYPE.LITE ? '#341A00' : 'linear-gradient(180deg, #003255 0%, #210F03 41.59%)' }" style="padding: 32px 40px;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <img style="width: 70px;" :src="require('@/assets/img/title.png')" alt="">
                </div>
                <!-- <div style="display: flex; gap: 12px; color: #fff;">
                    <div @click="setType(POSITION_TYPE.LITE)" style="cursor: pointer;" :style="{ fontWeight: type === POSITION_TYPE.LITE ? '700' : '400' }">{{ headerText.position_lite_btn }}</div>
                    <div @click="setType(POSITION_TYPE.PRO)" style="cursor: pointer;" :style="{ fontWeight: type === POSITION_TYPE.PRO ? '700' : '400' }">{{ headerText.position_pro_btn }}</div>
                </div> -->
            </div>
            <div style="margin-top: 40px; text-align: center;">
                <img style="width: 136px;" :src="require(`@/assets/img/${type}_ground.png`)" alt="">
                <div style="margin-top: 40px; color: #fff;">
                    <div style="font-weight: 700; font-size: 24px; line-height: 28px;">{{ type === POSITION_TYPE.LITE ? headerText.title.lite : headerText.title.pro }}</div>
                    <div v-html="subTitle" style="font-weight: 500; line-height: 24px; margin-top: 20px;"></div>
                </div>
            </div>
            <div style="text-align: center; margin-top: 40px;">
                <a v-if="type === POSITION_TYPE.LITE" style="">
                    <div style="-webkit-appearance:none; outline: none;border:0px;display: flex; align-items: center; gap: 10px;padding: 12px 20px; cursor: pointer; border-radius: 100px; background-color: var(--color-main);" @click="startFindPosition">
                        <span style="font-weight: 700; font-size: 14px; line-height: 24px; cursor: pointer;">포지션 찾기 시작하기</span>
                        <img style="width: 16px;" :src="require(`@/assets/img/do_${type}.png`)" alt="">
                    </div>
                </a>
                <div v-else :style="{ backgroundColor: type === POSITION_TYPE.LITE ? 'var(--color-main)' : '#315997' }" style="padding: 12px 20px; display: inline-block; cursor: pointer; border-radius: 100px;" @click="showQr(true)">
                    <div style="display: flex; align-items: center; gap: 10px">
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px; color: #fff; cursor: pointer;">APP에서 포지션 찾기 PRO 시작하기</div>
                        <img style="width: 16px;" :src="require(`@/assets/img/do_${type}.png`)" alt="">
                    </div>
                </div>
            </div>
        </div>
        <template v-if="type === POSITION_TYPE.LITE">
            <PositionLite :showQr="showQr"></PositionLite>
        </template>
        <template v-else>
            <PositionPro :showQr="showQr"></PositionPro>
        </template>
        <div style="background-color: #341A00;">
            <div style="padding: 0 20px;">
                <div style="margin-top: 32px;">
                    <img style="width: 70px;" :src="require('@/assets/img/title.png')" alt="">
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center;">
                    <div style="display: flex; gap: 4px; align-items: center;">
                        <div @click="showQr" style="font-weight: 700;font-size: 12px;line-height: 24px; color: var(--color-main); cursor: pointer;">{{ footerText.title1 }}</div>
                        <img style="width: 12px;" :src="require('@/assets/img/down.png')" alt="">
                    </div>
                    <div @click="showPrivacyPolicy" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; cursor: pointer;">{{ footerText.title2 }}</div>
                    <div @click="showHelpPage" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; padding-bottom: 32px; cursor: pointer;">{{ footerText.title3 }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { POSITION_TYPE, WEB_PLATFORM_TYPE } from '@/Constants';
import PositionLite from '@/components/common/PositionLite'
import PositionPro from '@/components/common/PositionPro'

export default {
    name: 'PositionWeb',
    data() {
        return {
            POSITION_TYPE: POSITION_TYPE,
            type: POSITION_TYPE.LITE,
            subTitle: '진짜 내가 잘할 수 있는 포지션이 궁금하지 않으세요?<br> 단 몇 가지 대답으로 나에게 어울리는 축구 포지션을 찾아보세요.',
            platform: '',
            qrSrc: '',
            isShowQr: false,
            isPro: false,
            device: '',
        }
    },
    computed: {
        headerText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.header;
        },
        footerText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.footer;
        },
        nextFindPath() {
            return location.pathname === '/' ? '/view/position_web?m=1' : '/?m=1';
        }
    },
    components: {
        PositionLite, PositionPro
    },
    methods: {
        showHelpPage() {
            const platForm = this.$Util.getWebPlatForm();

            if (platForm !== WEB_PLATFORM_TYPE.OTHER) {
                if (JSON.parse(process.env.VUE_APP_IS_TEST_SERVER)) {
                    this.$Util.showBrowser('https://obyungear-user-test.ubiplus.co.kr/help')
                } else {
                    this.$Util.showBrowser('https://obyungear-user.ubiplus.co.kr/help')
                }
            } else {
                if (JSON.parse(process.env.VUE_APP_IS_TEST_SERVER)) {
                    window.open('https://obyungear-user-test.ubiplus.co.kr/help')
                } else {
                    window.open('https://obyungear-user.ubiplus.co.kr/help')
                }
            }
        },
        showPrivacyPolicy() {
            this.$GlobalStore.setIsShowPrivacyPolicy()
        },
        showQr() {
            const platForm = this.$Util.getWebPlatForm();

            if (platForm === WEB_PLATFORM_TYPE.OTHER) {
                if (this.type === POSITION_TYPE.LITE) {
                    this.isPro = false
                } else {
                    this.isPro = true
                }
                this.isShowQr = true
            } else {
                this.showInApp()
            }
        },
        showInApp() {
            let schemes = this.$GlobalStore.schemes();
            let schemes_str = 'action=' + schemes.action;
            if (schemes.param0) schemes_str += '&param0=' + schemes.param0;
            if (schemes.param1) schemes_str += '&param1=' + schemes.param1;
            if (schemes.param2) schemes_str += '&param2=' + schemes.param2;

            // console.log(schemes_str);
            const userAgent = navigator.userAgent;

            if (userAgent.match(/android/i)) {
                location.href = `intent://action?${schemes_str}#Intent;scheme=obyungearuser;package=com.ubiplus.custom.obyungear_user;end`
            } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
                const visitedAt = (new Date()).getTime(); // 방문 시간
                setTimeout(function () {
                    if ((new Date()).getTime() - visitedAt < 2000) {
                        location.href = 'itms-apps://itunes.apple.com/app/id6443870201';
                    }
                }, 1500);
                setTimeout(function () {
                    location.href = `obyungearuser://?${schemes_str}`;
                }, 0);
            }
        },
        goToInstallLink() {
            const platForm = this.$Util.getWebPlatForm();
            if (platForm === WEB_PLATFORM_TYPE.ANDROID) {
                window.open('https://play.google.com/store/apps/details?id=com.ubiplus.custom.obyungear_user')
            } else if (platForm === WEB_PLATFORM_TYPE.IOS) {
                window.open('https://itunes.apple.com/app/id6443870201');
            }
        },
        closeQr() {
            this.isShowQr = false
            this.isPro = false
        },
        setType(type) {
            this.type = type
            if (this.type === POSITION_TYPE.LITE) {
                this.subTitle = this.headerText.sub_title.lite
            } else {
                this.subTitle = this.headerText.sub_title.pro
            }
        },
        startFindPosition() {
            this.$GlobalStore.addModal('FindPositionLite')
            // this.setSessionStorage()
        },
        setSessionStorage() {
            // const session_storage_key = 'IS_FROM_BTN'
            // sessionStorage.setItem(session_storage_key, true)
        },
        setQrSrc() {
            const device = this.$cookies.get('device')
            this.device = device
            this.platform = this.$Util.getWebPlatForm()
            if (this.platform === WEB_PLATFORM_TYPE.ANDROID) {
                this.qrSrc = require('@/assets/img/android_qr.png')
            } else if (this.platform === WEB_PLATFORM_TYPE.IOS) {
                this.qrSrc = require('@/assets/img/ios_qr.png')
            } else {
                this.qrSrc = require('@/assets/img/android_qr.png')
            }
        },
        detectAccessedByButton() {
            const session_storage_key = 'IS_FROM_BTN'
            const isAccessedByButton = sessionStorage.getItem(session_storage_key)

            if (isAccessedByButton) {
                this.$GlobalStore.addModal('FindPositionLite')
                sessionStorage.removeItem(session_storage_key)
            }

        },
    },
    mounted() {
        if (this.$route.query.m && this.$route.query.m === '1') {
            this.$GlobalStore.addModal('FindPositionLite')
            history.pushState({}, '', location.pathname)
        }
    },
    created() {
        this.$Util.checkAppLinkPageShow()
        this.setQrSrc()
        // this.detectAccessedByButton()
    }
}
</script>

<style scoped>
a {
    all: unset;
    cursor: pointer;
    display: inline-block;
    text-decoration: none;
    color: inherit;
}
</style>